import { MODULE_TYPE, PRESCRIPTION_INTEGRATION } from '@abiglobalhealth/go-types'

import { useModule } from '@/hooks/useModule'
import { usePrescription } from '@/hooks/usePrescription'

import { DoseSpotPharmacySelector } from './integration/DoseSpot'
import { HealthMailPharmacySelector } from './integration/HealthMail'

export const PharmacySelector = () => {
  const { prescription } = usePrescription()
  const { currentModule } = useModule()

  const integration = prescription?.integration || (currentModule?.type === MODULE_TYPE.PHARMACY_SELECTOR ? currentModule?.integration : null)

  if (!integration) return <p>No integration found</p>

  switch (integration) {
    case PRESCRIPTION_INTEGRATION.HEALTHMAIL:
    case PRESCRIPTION_INTEGRATION.HEALTHMAIL_DOUGLASDALE:
    case PRESCRIPTION_INTEGRATION.HEALTHMAIL_ILH:
      return <HealthMailPharmacySelector />

    case PRESCRIPTION_INTEGRATION.DOSE_SPOT:
      return <DoseSpotPharmacySelector />

    default:
      return <p>No pharmacy selector found for {prescription?.integration}</p>
  }
}
